import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { httpOptions, api, serviceConstants, formOptions } from '../../constants/service.constants';
import { Observable } from 'rxjs';
import { INSTRUCTION, GM_APP, DocumentModel, ScreenResponseModel, Model, AudienceModel, ReconModel, AdvModel } from 'src/app/models/common';
import { MasterDropDown } from '../common/common-summary.service';

@Injectable({
  providedIn: 'root'
})
export class GrantsSummaryService {

  constructor(private http: HttpClient) {

  }
  GetMasterScreenData(Url: any): Observable<any> {
    return this.http.get((serviceConstants.apiURL + Url), httpOptions);
  }

  getScreenDataForEdit(url: any) {
    return this.http.get(serviceConstants.apiURL + url, httpOptions);
  }
  

  getApplicationSummary(url: any): Observable<any> {
    return this.http.get(serviceConstants.apiURL + url, httpOptions);
  }
  PostSearchSummary(url: any,formData:any): Observable<any> {
    return this.http.post(serviceConstants.apiURL + url, formData, httpOptions);
  }
  
  getDeliveryFormatSummary(_id?,AppID?): Observable<any> {
    return this.http.get(serviceConstants.apiURL + "api/gmdeliveryformat/getdeliveryformat/" + _id + "/"+ AppID, httpOptions);
  }

  getDocumentUpload(_id?): Observable<any> {
    
    return this.http.get(serviceConstants.apiURL + "api/gmdocumentupload/getdocumentupload/" + _id, httpOptions);
  }

  getTherapeuticAreaList(_id?): Observable<any> {
    return this.http.get(serviceConstants.apiURL + "api/gmdeliveryformat/gettherapeuticarealist/" + _id, httpOptions);
  }

  getLookupList(_id?,AppID:string=""): Observable<any> {
    return this.http.get<MasterDropDown[]>(serviceConstants.apiURL + `api/gmaudience/getlookuplist?id=${_id}&AppID=${AppID}`, httpOptions);
  }
  getLookupListForSearch(_id?,appid?): Observable<MasterDropDown[]> {
    return this.http.get<MasterDropDown[]>(serviceConstants.apiURL + "api/gmaudience/getLookupListForSearch/" + _id+"/"+appid, httpOptions);

  }

  getBudgetTypeList(appID?,RecordID?): Observable<any> {
    return this.http.get(serviceConstants.apiURL + "api/gmbudget/getfundcategorylist/"+ appID+"/"+RecordID, httpOptions);
  }

  getBudgetSubTypeList(model: ScreenResponseModel): Observable<any> {
    return this.http.post(serviceConstants.apiURL + "api/gmbudget/getfundsubcategorylist", model, httpOptions);
  }

  getCurrency(appId: any): Observable<any> {
    return this.http.get(serviceConstants.apiURL + "api/gmbudget/GetCurrency/" + appId, httpOptions);
  }

  getScreenControlsList(id,appId): Observable<any> {
    return this.http.get(serviceConstants.apiURL + "api/screen/fetchresponsecontrols/" + id+"/"+appId, httpOptions);
  }
  getExtendedControlsList(id,appId): Observable<any> {
    return this.http.get(serviceConstants.apiURL + "api/screen/fetchextendedcontrols/" + id+"/"+appId, httpOptions);
  }
  getScreenResponse(model: ScreenResponseModel): Observable<any> {
    return this.http.post(serviceConstants.apiURL + "api/screenresponse/getscreenresponse", model, httpOptions);
  }
  getScreenResponseRow(model: ScreenResponseModel): Observable<any> {
    return this.http.post(serviceConstants.apiURL + "api/screenresponse/getscreenresponserow", model, httpOptions);
  }
  getExtendedScreenResponse(id, id1): Observable<any> {
    return this.http.get(serviceConstants.apiURL + "api/screenresponse/getextendedscreenresponse/" + id + "/" + id1, httpOptions);
  }
  getInstruction(id): Observable<any> {
    return this.http.get(serviceConstants.apiURL + "api/instruction/getinstructionbycode/" + id, formOptions);
  }

  gmappInsert(body: GM_APP): Observable<any> {
    return this.http.post(serviceConstants.apiURL + "api/gmapp/insert/", body, httpOptions);
  }

  getRecordById(url: any, id: any): Observable<any> {
    return this.http.get(serviceConstants.apiURL + url+ "/" + id, httpOptions);
  }

  FilesInsert(url: any, body: any): Observable<any> {
    return this.http.post(serviceConstants.apiURL + url, body, formOptions);
  }

  Insert(url: any, body: any): Observable<any> {
    return this.http.post(serviceConstants.apiURL + url, body, httpOptions);
  }

  Update(url: any, body: any): Observable<any> {
    return this.http.post(serviceConstants.apiURL + url, body, httpOptions);
  }

  Upload(url: any, body: any): Observable<any> {
    return this.http.post(serviceConstants.apiURL + url, body, formOptions);
  }

  getGrantSearchSummary(url: any, body: any): Observable<any> {
    return this.http.get(serviceConstants.apiURL + url, httpOptions);
  }

  getGrantApps(url: any, body: any): Observable<any> {
    return this.http.get(serviceConstants.apiURL + url, httpOptions);
  }

  getGrantAppAdvSearch(url: any, searchObject: any): Observable<any> {
    return this.http.post(serviceConstants.apiURL + url, searchObject, httpOptions);
  }

  Delete(url: any): Observable<any> {
    return this.http.get((serviceConstants.apiURL + url), httpOptions);
  }

  getRecord(url: any, id: string ) {
    return this.http.get((serviceConstants.apiURL + url + id), httpOptions);
  }

  statusupdate(url: any, id: any, status: any): Observable<any> {
     ;
    //return this.http.get(url, httpOptions);
    return this.http.get(serviceConstants.apiURL + url + id + "/" + status, httpOptions);
  }

  deleteRecord(url: any,id: any, appId: any): Observable<any> {
     ;
    //return this.http.get(url, httpOptions);
    return this.http.get(serviceConstants.apiURL + url + id+ "/" + appId, httpOptions);
  }
  getBudget(id,AppID?): Observable<any> {
    return this.http.get(serviceConstants.apiURL + "api/gmbudget/getbuget/" + id + "/" + AppID, httpOptions);
  }
  getData(url: string): Observable<any> {
    return this.http.get((serviceConstants.apiURL + url), httpOptions)
  }
  getReconsiliation(id,AppID): Observable<any> {
    return this.http.get(serviceConstants.apiURL + "api/gmconciliation/getbuget/" + id + "/"+ AppID, httpOptions);
  }
  getoutcomeassessment(id): Observable<any> {
    return this.http.get(serviceConstants.apiURL + "api/gmassessment/getassessment/" + id, httpOptions);
  }

  getSignee(id): Observable<any> {
    return this.http.get(serviceConstants.apiURL + "api/gmsignee/getsignee/" + id, httpOptions);
  }

  getSigneeCopyData(id): Observable<any> {
    return this.http.get(serviceConstants.apiURL + "api/gmsignee/getsigneecopydata/" + id, httpOptions);
  }

  getAudience(id): Observable<any> {
    return this.http.get(serviceConstants.apiURL + "api/gmaudience/getaudience/" + id, httpOptions);
  }
  getAudienceList(id): Observable<any> {
    return this.http.get(serviceConstants.apiURL + "api/screen/fetchscreencontrols/" + id, httpOptions);
  }
  getModulesList(): Observable<any> {
    return this.http.get(serviceConstants.apiURL + "api/screen/getmodules/", httpOptions);
  }

  deleteAudience(id: any): Observable<any> {
     ;
    //return this.http.get(url, httpOptions);
    return this.http.get(serviceConstants.apiURL + "api/gmaudience/delete/" + id, httpOptions);
  }

  deleteOutcome(id: any): Observable<any> {
     ;
    //return this.http.get(url, httpOptions);
    return this.http.get(serviceConstants.apiURL + "api/gmassessment/delete/" + id, httpOptions);
  }

  // Screen controls  methods
  getAudienceSummary(text: any, type: any, appid: any): Observable<any> {
    return this.http.get(serviceConstants.apiURL + "api/gmaudience/fetchsummary/" + text + "/" + type + "/" + appid, httpOptions);
  }

  getAudienceSummaryAdvSearch(model: AudienceModel): Observable<any> {
    return this.http.post(serviceConstants.apiURL + "api/gmaudience/fetchsummaryadv", model, httpOptions);
  }

  getBudgetSum(text: any, type: any): Observable<any> {
    return this.http.get(serviceConstants.apiURL + "api/gmbudget/getbudgetsum/" + text + "/" + type, httpOptions);
  }

  getBudgetsAdvanceSummary(text: any, type: any, appid: any, btypeid: any, bsubtypeid: any, status: any): Observable<any> {
    var formData = new Object();
    formData["text"] = text;
    formData["type"] = type;
    formData["appid"] = appid;
    formData["btypeid"] = btypeid;
    formData["bsubtypeid"] = bsubtypeid;
    formData["status"] = status;

    return this.http.post(serviceConstants.apiURL + "api/gmbudget/fetchadvancesummary", formData, httpOptions);
  }


  getBudgetsSummary(model: Model): Observable<any> {
    return this.http.post(serviceConstants.apiURL + "api/gmbudget/fetchsummary", model, httpOptions);
  }
  getReconsiliationsSummary(model: Model): Observable<any> {
    return this.http.post(serviceConstants.apiURL + "api/gmconciliation/fetchsummary", model, httpOptions);
  }

  getReconsiliationsAdvanceSummary(model: ReconModel): Observable<any> {
    return this.http.post(serviceConstants.apiURL + "api/gmconciliation/fetchadvancesummary", model, httpOptions);
  }
  getAuthorizedSigneeSummary(model: Model): Observable<any> {
    return this.http.post(serviceConstants.apiURL + "api/gmsignee/fetchsummary", model, httpOptions);
  }
  getAuthorizedSigneeSummaryAdvSearch(model:AdvModel): Observable<any> {
    return this.http.post(serviceConstants.apiURL + "api/gmsignee/fetchadvsummary", model, httpOptions);
  }
  getOutcomeSummary(model: Model): Observable<any> {
    return this.http.post(serviceConstants.apiURL + "api/gmassessment/fetchsummary", model, httpOptions);
  }
  getOutcomeSummarySearch(searchData:any): Observable<any> {
    return this.http.post(serviceConstants.apiURL + "api/gmassessment/fetchsummarySearch",searchData, httpOptions);
  }

  makedefaultsignee11(id: any): Observable<any> {
    return this.http.get(serviceConstants.apiURL + "api/gmsignee/makedefault/" + id, httpOptions);
  }

  makeDefaultSignee(id: string): Observable<any> {
    return this.http.get(serviceConstants.apiURL + "api/gmsignee/makedefault/" + id, httpOptions);
  }

  resendUserEmail(ID:string,OrgId:string) : Observable<any> {
    return this.http.get(serviceConstants.apiURL + 'api/appuser/resenduseremail/'+ID+'/'+OrgId, httpOptions);
  }

  SigneeDefault(id: string): Observable<any> {
    return this.http.get(serviceConstants.apiURL + "api/gmsignee/makedefault/" + id, httpOptions);
  }
 DeleteSignee(id: string): Observable<any> {
    return this.http.get(serviceConstants.apiURL + "api/gmsignee/delete/" + id, httpOptions);
  }
  getFeatureDocuments(model: DocumentModel): Observable<any> {
    return this.http.post(serviceConstants.apiURL + "api/screen/getfeaturedocuments", model, httpOptions);
  }

  saveFeatureDocuments(formData: FormData): Observable<any> {
    return this.http.post(serviceConstants.apiURL + "api/screen/savefeaturedocuments", formData, formOptions);
  }

  getCharityGeneralInfo(Url: any): Observable<any> {
    return this.http.get(serviceConstants.apiURL + Url, httpOptions);
  }
  getCharityAppSummary(url: any): Observable<any> {
    return this.http.get(serviceConstants.apiURL + url, httpOptions);
  }
  SaveCharityGeneralInfo(url: any, formData: any): Observable<any> {
    return this.http.post(serviceConstants.apiURL + url, formData, formOptions);
  }

  getGeneralInformationCME(Url:any): Observable<any> {
    return this.http.get(serviceConstants.apiURL+Url, httpOptions);
  }
  getCMEApplicationSummary(url: any): Observable<any> {
    return this.http.get(serviceConstants.apiURL + url, httpOptions);
  }
  SaveCMEGeneralInfo(url:any,formData:any): Observable<any> {
    return this.http.post(serviceConstants.apiURL+url, formData, httpOptions);
  }
  SaveCMEGrantInfo(url:any,formData:any): Observable<any> {
    return this.http.post(serviceConstants.apiURL+url, formData, httpOptions);
  }
  getGGIData(url: any) {
    return this.http.get(serviceConstants.apiURL+url, httpOptions);
  }

  saveGRTUploadDocDocuments(formData: FormData): Observable<any> {
    return this.http.post(serviceConstants.apiURL + "api/GMDocumentUpload/InsertgrtSposUploadDoc", formData, formOptions);
  }

  FetchProfileUptoDate(id: string): Observable<any> {
    return this.http.get(serviceConstants.apiURL + "api/GMDocumentUpload/FetchProfileUptoDate/" + id, httpOptions);
  }

  updateUser(url: any, body: any) {
    return this.http.post(serviceConstants.apiURL + url,body, httpOptions);
  }

  FetchStatusType(url: any): Observable<any> {
    return this.http.get(serviceConstants.apiURL + url, httpOptions);
  }

  GetregistrationProgram(url: any): Observable<any> {
    return this.http.get(serviceConstants.apiURL+url, httpOptions);
  }
}
